import { Card } from 'components/Card'
import { Checklist, ChecklistProps } from './CheckList'

export const ChecklistCard: React.CFC<ChecklistProps> = ({
  checklist,
  ...rest
}) => {
  if (checklist === null) return null
  return (
    <Card>
      <Checklist checklist={checklist} {...rest} />
    </Card>
  )
}
